import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import MDBox from 'components/MDBox';
import DashboardNavbar from '../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../LayoutContainers/DashboardLayout';
import { BuildingsList } from 'components/Building/BuildingList';

export const ManageDevices = () => {
  const dispatch = useDispatch();

  return (
    <DashboardLayout>
      <DashboardNavbar objectName="manage buildings" />
      <Typography fontSize="11px" sx={{ paddingLeft: { xs: 0, sm: '12px' }, marginTop: { xs: '-15px', sm: '-5px' }, textAlign: { xs: 'center', sm: 'left' } }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox>
        <Grid container>
          <Grid item xs={12}>
            <BuildingsList />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default ManageDevices;
